import request from '@/utils/request'

// 保存
export function apiInvCallRequestLinesStockTransfer (data) {
  return request({
    url: '/inv/invCallRequestLines/stockTransfer',
    method: 'put',
    data: data
  })
}

// 工单号
export function apiInvCallRequestLinesWipEntityNameBox (query) {
  return request({
    url: '/inv/invCallRequestLines/wipEntityNameBox',
    method: 'get',
    params: query
  })
}

// 工单号-带出数据
export function apiInvCallRequestLinesWipEntityNameToData (query) {
  return request({
    url: '/inv/invCallRequestLines/wipEntityNameToData',
    method: 'get',
    params: query
  })
}

// 带出现有量可用量数据
export function apiInvCallRequestLinesStockTransferToData (query) {
  return request({
    url: '/inv/invCallRequestLines/stockTransferToData',
    method: 'get',
    params: query
  })
}
